<div class="overlay" [class.visible]="isVisible" (click)="closeSidebar(false)"></div>

<div class="sidebar" [ngClass]="{
  'visible': isVisible && !isMobile,
  'isVisibleMobile': isVisible && isMobile
}">
<div class="page-layout blank fullwidth p-12" style="height: 1px; overflow-y: scroll;    top: 1px;z-index: 1000;">

    <div class="order-container">
        <header>
          <div class="back-button">
            <i (click)="closeSidebar(false)" class="material-icons" style="color: black;font-weight: bold;">arrow_back</i>
            <span class="order-id" *ngIf="orderDetails?.orderNumber">Order ID# {{orderDetails.orderNumber}}</span>
            <span class="order-id" *ngIf="!orderDetails?.orderNumber">Order ID# {{orderDetails.orderId}}</span>

             <span class="order-total">
              ₹{{orderDetails.grandTotal+orderDetails.shippingCharges |  number: '1.2-2'}}
             </span>
             <i class="material-icons" style="width: 1%;cursor: pointer;" (click)="openMenu()">more_vert</i>
          </div>
          
        </header> 
        <div class="overlay" [class.visible]="isBottomSheetOpen" (click)="closeMenu()"></div>
        <div class="bottom-sheet1" *ngIf="isBottomSheetOpen" >
            <mat-nav-list>
              <mat-list-item (click)="shareOnWhatsApp()">
                <span class="names">Share Tracking Page</span>
                <i class="material" >share</i>
              </mat-list-item>
              <mat-divider></mat-divider>
              <mat-list-item (click)="openDownload()" *ngIf='invoice.length>1'>
                <span class="names">Download Invoice</span>
                <img src="../../../../assets/images/download.png" style="height: 24px;cursor: pointer;"  alt="">
              </mat-list-item>
              <mat-list-item (click)="openInvoiceUrl(invoiceUrl)" *ngIf='invoice.length<=1'>
                <span class="names">Download Invoice</span>
                <img src="../../../../assets/images/download.png" style="height: 24px;cursor: pointer;"  alt="">
              </mat-list-item>
              <mat-divider></mat-divider>
              <!-- <mat-list-item (click)="openSidebarQuote()">
                <span class="names">Register Parts</span>
                <i class="material" >edit</i>
              </mat-list-item> -->
              <mat-list-item *ngIf="(deliveryData[selectedDelivery]?.shipmentStatus=='delivered') && showBrandButton">
                <span class="names" (click)="openRegisterSheet()">Issue Warranty Certificate</span>
                <i class="material" >book</i>
              </mat-list-item>
            </mat-nav-list>
        </div>
         <div class="overlay" [class.visible]="trackItem" (click)="closeTrackItem()"></div>

<!-- <div class="bottom-sheet1" *ngIf="trackItem">
<div class="track-return-wrapper">
  <div class="header">
    <h3>Track Return</h3>
    <p>Return ID: {{ returnData.salesReturnId }}</p>
  </div>

  <div class="timeline">
    <div class="step" [ngClass]="{'active': true}">
      <div class="icon"><span class="material-icons">check</span></div>
      <div class="content">
        <div class="title">Return Request Submitted</div>
        <div class="date">on {{ getFormattedDate(returnData.createdAt) }}</div>
      </div>
    </div>

    <div class="step" 
         [ngClass]="{'active': returnData.receiveStatus === 'received', 'declined': returnData.activity === 'Declined'}">
      <div class="icon">
        <span *ngIf="returnData.receiveStatus === 'received'" class="material-icons">check</span>
        <span *ngIf="returnData.activity === 'Declined'" class="material-icons">cancel</span>
        <span *ngIf="!returnData.receiveStatus && returnData.activity !== 'Declined'" class="circle-num"> </span>
      </div>
      <div class="content">
        <div class="title" [ngClass]="{'decline': returnData.activity === 'Declined'}">
          {{ returnData.activity === 'Declined' ? 'Declined' : 'Return Item Received' }}
        </div>
        <div class="date" *ngIf="returnData.receiveStatus === 'received'">
          on {{ getFormattedDate(returnData.salesReturnRecvDate) }}
        </div>
        <div class="date" *ngIf="returnData.activity === 'Declined'">
          Item return declined
        </div>
      </div>
    </div>

    <div class="step" [ngClass]="{'active': returnData.refundStatus === 'refunded'}">
      <div class="icon">
        <span *ngIf="returnData.refundStatus === 'refunded'" class="material-icons">check</span>
        <span *ngIf="returnData.refundStatus !== 'refunded'" class="circle-num"> </span>
      </div>
      <div class="content">
        <div class="title">Credit Note Created</div>
        <div class="date" *ngIf="returnData.refundStatus === 'refunded'">
          on {{ getFormattedDate(returnData.creditNoteDate || returnData.createdAt) }}
        </div>
      </div>
    </div>
  </div>
</div>

</div> -->
<div class="return-card" *ngIf="trackItem">
  <div class="return-ids">
    <h3>{{ returnData.salesReturnInfo.salesReturnNumber }}</h3>
    <i (click)="closeTrackItem()">close</i>
  </div>
  <p class="return-timeline">Return Timeline</p>
 <div class="timeline">
  <!-- Step 1 -->
  <div class="timeline-step" [ngClass]="{ 'active-timeline': returnData?.salesReturnInfo?.returnCreatedAt }">
    <span class="status-indicator"
  [ngClass]="{ 'active-circle': returnData?.salesReturnInfo?.returnCreatedAt, 'inactive': !returnData?.salesReturnInfo?.returnCreatedAt }"></span>
    <div class="content">
      <strong>Return Created</strong>
      <div class="timeline-date">{{ returnData?.salesReturnInfo?.returnCreatedAt | date: 'MMM d, y' }}</div>
    </div>
  </div>

  <!-- Step 2 -->
  <!-- <div class="timeline-step" [ngClass]="{ 'active-timeline': returnItems.shippedDate,'pending': !returnItems.shippedDate }">
    <span class="status-indicator"
  [ngClass]="{ 'active-circle': returnItems.shippedDate, 'inactive': !returnItems.shippedDate }"></span>
    <div class="content">
      <strong>Item Shipped</strong>
      <div class="timeline-date">{{ returnItems.shippedDate || 'Pending' }}</div>
    </div>
  </div> -->

  <!-- Step 3 -->
  <div class="timeline-step" *ngIf="statusInfo[1]?.activity !== 'declined'" [ngClass]="{ 'active-timeline': statusInfo[0].receiveDate,
  'pending': ! statusInfo[0].receiveDate }">
    <span class="status-indicator"
  [ngClass]="{ 'active-circle':  statusInfo[0].receiveDate, 'inactive': ! statusInfo[0].receiveDate }"></span>
    <div class="content">
      <strong>Item Received</strong>
      <div class="timeline-date">{{ ( statusInfo[0].receiveDate | date: 'MMM d, y') || 'Pending' }}</div>
    </div>
  </div>

  <!-- Step 4 -->
  <div *ngIf="statusInfo[1]?.activity !== 'declined'" class="timeline-step"
       [ngClass]="{
         'active-timeline': statusInfo[1]?.refundDate,
         'pending': !statusInfo[1]?.refundDate
       }">
    <span class="status-indicator"
  [ngClass]="{ 'active-circle': statusInfo[1]?.refundDate, 'inactive': !statusInfo[1]?.refundDate }"></span>
    <div class="content">
      <strong>Refund Processed</strong>
      <div class="timeline-date">{{( statusInfo[1]?.refundDate | date: 'MMM d, y') || (statusInfo[1]?.refundStatus) || 'Pending' }}</div>
    </div>
  </div>

 <div *ngIf="statusInfo[1]?.activity == 'declined'" class="timeline-step"
       [ngClass]="{
         'active-timeline': statusInfo[1]?.declinedDate,
         'pending': !statusInfo[1]?.declinedDate
       }">
    <span class="status-indicator"
  [ngClass]="{ 'active-circle': statusInfo[1]?.declinedDate, 'inactive': !statusInfo[1]?.declinedDate }"></span>
    <div class="content">
      <strong>Return Declined</strong>
      <div class="timeline-date">{{ (statusInfo[1]?.declinedDate | date: 'MMM d, y') || 'Pending' }}</div>
    </div>
  </div>

  <hr />

  <div class="details-timeline">
    <h3>Return Details</h3>
    <p class="name">{{ returnData?.itemInfo?.itemName }}</p>
    <p class="reason"> <strong>Reason:</strong> {{ returnData?.salesReturnInfo?.returnReason }}</p>
    <!-- <small>Sales Order: {{ returnData?.salesReturnInfo?.salesOrderNumber }} | Order Date: {{ returnData?.salesReturnInfo?.purchasedDate | date: 'MMM d, y' }}</small> -->
     <div class="small-and-small1">
        <small class="small">
            Invoice: {{ invoiceNumber || 'N/A' }} |
            Part No:
            {{ returnData?.itemInfo?.partNumber }}
        </small>
        <small class="small1">
          Order ID: {{ orderNumber || 'N/A' }} |
          <!-- Order Date: {{ returnData?.salesReturnInfo?.purchasedDate | date:'MMM dd, yyyy' }} -->
          Order Date: {{ orderDate | date:'MMM dd, yyyy' }}
        </small>
      </div>
  </div>

  
  <!-- Declined -->
  <!-- <div *ngIf="statusInfo[1]?.activity == 'declined'" class="declined">
    <div class="content">
      <strong>Return Declined</strong>
      <div class="timeline-date">Return period expired (30 days)</div>
    </div>
  </div> -->
</div>
  <hr />

  <div class="actions">
    <button *ngIf="returnData?.salesReturnInfo?.creditNoteUrl" class="download-btn" (click)="downloadFile()">Download Credit Note</button>
    <button class="close-btn1" (click)="closeTrackItem()">Close</button>
  </div>
</div>

        <div class="overlay" [class.visible]="isDownloadBottomSheet" (click)="openDownload()"></div>
        <div class="bottom-sheet2" *ngIf="isDownloadBottomSheet" >
          <h3> Download Invoice</h3>
            <mat-nav-list  *ngFor="let invoices of invoice">
              <mat-list-item (click)="openInvoiceUrl(invoices.invoiceUrl)">
                <span class="names" style="display: grid;">{{invoices.invoiceNumber}} 
                  <span>₹ {{invoices.totalAmount}} | {{invoices.totalQuantity}} {{ invoices.totalQuantity === 1 ? 'item' : 'items' }}</span></span>
                <img src="../../../../assets/images/download.png" style="height: 24px;cursor: pointer;"  alt="">
              </mat-list-item>
              <mat-divider></mat-divider>
            </mat-nav-list>
        </div>
        <div *ngIf="orderDetails.magicQuote==1" style="margin-bottom: 12px">
          <img class="magic" src="../../../../assets/images/order-details/magic.jpg">
        </div>
                      
        <div class="savings-info">
          You have saved ₹{{orderDetails.discount}} on this order
        </div>
        <!-- <div style="margin-top: 7px; margin-bottom: 24px;">
          <div class="logo-container"  *ngIf="orderDetails?.make">
            <div class="logo">
            <img 
                [src]="'https://cube.getpitstop.com/assets/img/' + orderDetails.make.toLowerCase().replace(' ', '') + '.png'" 
                alt="Make Image"
              >
            </div>
          </div>
    
      <div class="model-sec" style="width:80%;line-height: 2.4px;" *ngIf="orderDetails?.model">
        <p style="font-weight:bold">{{orderDetails.model}}, {{orderDetails.fuelType}}</p>
        <p>{{orderDetails.variant}} [{{orderDetails.mfgYear}}]</p>
        <p style="margin-bottom: -10px;"  *ngIf="orderDetails?.registrationNumber">{{orderDetails.registrationNumber}}</p>
    </div>
  </div> -->
  <div style="margin-top: 7px; margin-bottom: 10epx; ">
  
  <!-- If make is present -->
  <ng-container *ngIf="orderDetails?.make">
    <div class="logo-container">
      <div class="logo">
        <img 
          [src]="'https://cube.getpitstop.com/assets/img/' + orderDetails.make.toLowerCase().replace(' ', '') + '.png'" 
          alt="Make Image"
        >
      </div>
    </div>

    <div class="model-sec" style="width:80%; line-height: 2.4px;" *ngIf="orderDetails?.model">
      <p style="font-weight:bold">{{orderDetails.model}}, {{orderDetails.fuelType}}</p>
      <p>{{orderDetails.variant}} [{{orderDetails.mfgYear}}]</p>
      <p style="margin-bottom: -10px;" *ngIf="orderDetails?.registrationNumber">
        {{orderDetails.registrationNumber}}
      </p>
    </div>

    <div class="model-sec" style="width:80%; line-height: 2.4px;" *ngIf="!orderDetails?.model">
      <img src="../../../../assets/images/ac_car_icon.svg" style="width: 24px; height: 24px; margin-right: 6px;" alt="car-icon">
      <span *ngIf="orderDetails?.registrationNumber">{{orderDetails.registrationNumber}}</span>
    </div>
  </ng-container>

  <!-- If make is NOT present -->
  <div *ngIf="!orderDetails?.make && orderDetails?.registrationNumber"style="display: flex; align-items: center; ">
    <div class="logo-container" style="margin-bottom: 0px; margin-right: 10px;">
      <div class="logo">
        <img src="../../../../assets/images/ac_car_icon.svg" style="width: 24px; height: 24px; margin-left:4%;" alt="dummy-car">
      </div>
    </div>
      <span *ngIf="orderDetails?.registrationNumber">{{orderDetails.registrationNumber}}</span>
  </div>

</div>


  <div class="tab-container" *ngIf="deliveries.length>1">
   <div class="tab-scroll-wrapper">
  <button class="scroll-btn left" (click)="scrollTabs('left')" *ngIf="showRight">
    ‹
  </button>

  <div #tabScrollContainer class="tab-scroll-container"  (scroll)="onTabScroll()">
    <mat-button-toggle-group [(value)]="selectedDelivery" (click)="changeTab()" class="mat">
      <mat-button-toggle #deliveryToggle *ngFor="let delivery of deliveries" [value]="delivery" >
         <div >
         <img [src]="getImage(deliveryData[delivery]?.shipmentStatus)" alt="1" style="height: 23px; margin-top: 4px;"/>  
        {{ delivery }}
        </div>
        <p>{{deliveryData[delivery]?.itemCount}} {{ deliveryData[delivery]?.itemCount > 1 ? 'Items' : 'Item' }} &bull; 
           {{ deliveryData[delivery]?.shipmentStatus }}
        </p>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <button class="scroll-btn right" (click)="scrollTabs('right')"  *ngIf="showRight" >
    ›
  </button>
</div>

    
  </div>
  
  <div class="delivery-details">
    <!-- <h3>{{ selectedDelivery }} Arrived in 2 minutes</h3> -->
  </div>
  <!-- <div *ngIf="selectedDelivery">
  <h3>{{ selectedDelivery }}</h3>
  <p>Package No: {{ deliveryData[selectedDelivery].packageNumber }}</p>
  <p>Items Count: {{ deliveryData[selectedDelivery].itemCount }}</p>
  <p>Status: {{ deliveryData[selectedDelivery].shipmentStatus }}</p>

  <ul>
    <li *ngFor="let item of deliveryData[selectedDelivery].items">
      {{ item | json }} 
    </li>
  </ul>
</div> -->


        <div *ngIf="deliveries?.length> 1 && !(deliveryData[selectedDelivery]?.shipmentStatus == 'Confirmed')">
  
        <div class="delivery-info" >
          <p *ngIf="orderDeliveryTimeFormatted && orderDeliveryTimeFormatted !== '0 minutes' && deliveryData[selectedDelivery].deliveryTime !=null" class="delivery-time">
          {{ selectedDelivery | titlecase}} Arrived in  {{ orderDeliveryTimeFormatted }}</p>
           <div *ngIf="deliveryData[selectedDelivery]?.deliveryTime ==null" style="width: 100%;">
          <div class="expected-delivery-container">
            <div class="expected-header">
              <div class="tag-header">
              <img src="../../../../assets/images/order-details/right.png" class="icon-check">
              <span class="expected-title">Expected Delivery</span>
              </div>
              <div class="tag-slot smart-slot" *ngIf="orderDetails?.slotTag=='smartSlot'">
                <img src="../../../../assets/images/order-details/smart.png">
                <span>Smart Slot</span>
              </div>
               <div class="tag-slot smart-pickup" *ngIf="orderDetails?.slotTag=='pickUp'">
                <img src="../../../../assets/images/order-details/pick.png">
                <span>Pick Up</span>
              </div>
                <div class="tag-slot smart-instant" *ngIf="orderDetails?.slotTag=='instantDelivery'">
                <img src="../../../../assets/images/order-details/instant.png">
                <span>Instant</span>
              </div>
            </div>

  <div class="expected-time-box">
    <div class="tag-header">
    <div>
     <img src="../../../../assets/images/order-details//car.png">
     </div>
    <div class="time-line">
      <p class="time-text" *ngIf="orderDetails?.estimateSlotDeliveryTime != 'null' && !(orderDetails?.slotTag=='redeem')">
        <!-- {{ orderDetails.poEdt ? formatExpectedDeliveryTime(orderDetails.poEdt) : formatGoOrderEdt(orderDetails.orderConfirmTime) }} -->
          {{ formatExpectedDeliveryTime(orderDetails.estimateSlotDeliveryTime)  }}          
      </p>
       <p class="time-text" *ngIf="orderDetails?.estimateSlotDeliveryTime == 'null' && !(orderDetails?.slotTag=='redeem')">
        {{ formatGoOrderEdt(orderDetails.orderConfirmTime)  }}          
      </p>
        <p class="time-text" *ngIf="orderDetails?.slotTag=='redeem'">
        {{ orderDetails.reedemTag  }}          
      </p>
        <p class="slot-note" *ngIf="!(orderDetails?.slotTag)||orderDetails?.slotTag=='smartSlot'||orderDetails?.slotTag=='redeem'">Within your promised slot</p>
       <p class="slot-note" *ngIf="orderDetails?.slotTag=='pickUp'">Available at nearest store</p>
       <p class="slot-note" *ngIf="orderDetails?.slotTag=='instantDelivery'">Instant delivery</p>

    </div>
    </div>
    <div class="tag-slot smart-free" *ngIf="orderDetails?.shippingCharges==0">
      <span>₹{{orderDetails?.shippingCharges}} shipping</span>
    </div>
   <div class="tag-slot smart-fee" *ngIf="orderDetails?.shippingCharges>0">
      <span>₹{{orderDetails?.shippingCharges}} fee</span>
    </div>
  </div>
</div>
          </div>
         </div>
        <div class="order-tracking">
            <h2>Delivery Tracking</h2>
            
                
         <div class="progress-container">
    <div *ngFor="let status of statuses; let i = index" 
         [ngClass]="{'active': isActive(i), 'inactive': !isActive(i)}" 
         class="progress-step">
         <span class="circle">
            <i class="material-icons" style="font-size: 15px;color: white;padding: 2px;">check</i>
          </span>
         
         <div class="orderlist" > 

          <img [src]="getStatusImage(status)" alt="{{getStatusName(status)}}" style="height: 23px; margin-top: 2px;"/>  
          <div class="statusDate">
          <span *ngIf="getStatusName(status)=='Confirmed'" [ngClass]="{'active-text': isActive(i)}">Confirmed </span>
          <span *ngIf="getStatusName(status)=='Packed'" [ngClass]="{'active-text': isActive(i)}">Packed </span>
          <span *ngIf="getStatusName(status)=='On The Way'" [ngClass]="{'active-text': isActive(i)}"> On The Way </span>
          <span *ngIf="getStatusName(status)=='Delivered'" [ngClass]="{'active-text': isActive(i)}">Delivered </span>
          
          <p class="dates" *ngIf="isActive(i)">{{ getStatusDate(status)  | date:'dd-MMM-yyyy, hh:mm a' : 'GMT+1060'  }}</p>
          </div>
        </div>
      
    </div>
  </div>      
         
        </div>
        <div class="order-items">
          <h2>{{deliveryData[selectedDelivery]?.items?.length}} {{ deliveryData[selectedDelivery]?.items?.length > 1 ? 'Items' : 'Item' }} in this delivery</h2>
          <div *ngFor="let item of deliveryData[selectedDelivery]?.items">
            <div class="item">
              <span *ngIf="item.discount > 0" class="discount-badge">
                <!-- {{ ((item.discount / item.price) * 100) | number:'1.0-0' }}% Off -->
                {{ ((item.discount / (item.price + item.discount)) * 100) | number:'1.0-0' }}% Off
              </span>
              <img *ngIf="item.imageUrl"  [src]="item.imageUrl" onerror="this.src='../../../../assets/images/logos/logo.png'">
           
              <img *ngIf="!item.imageUrl" src="../../../../assets/images/logos/logo.png" alt="logo">
              <div class="item-details">
                <!-- <h3>{{item.partName}}</h3> -->
                <h3 class="truncate-text">{{ item.partName }}</h3>
                <p> {{ item.quantity }} {{ item.quantity > 1 ? 'Units' : 'Unit' }}</p>
                <p>{{item.brandName}}</p>
                <p>{{item.partNumber}}</p>
                <div style="display: flex;justify-content: space-between;">
                  <div>
                  <div class="price">
                    
                    <span class="discounted-price" *ngIf="item.price >0">₹{{item.price *item.quantity |  number: '1.2-2'}}</span>
                    <span class="original-price" *ngIf="item.discount>0">₹{{(item.price+item.discount)*item.quantity |  number: '1.2-2'}}</span>
                  </div>
                  <p class="savings" *ngIf="item.discount>0">You save ₹{{item.discount * item.quantity |  number: '1.2-2'}}</p>
                  </div>
                  <button class="return-item"  *ngIf="isReturned(item.partNumber) &&  deliveryData[selectedDelivery]?.shipmentStatus=='delivered' " (click)="trackReturn(item.partNumber)">Track Return</button>
                  <button class="return-item" *ngIf="(!isReturned(item.partNumber)) && (deliveryData[selectedDelivery]?.shipmentStatus=='delivered') && dueDate && hours<24" (click)="returnItem(item)">Return Item</button>

                  <button class="return-item"
                          *ngIf="!isReturned(item.partNumber) && (deliveryData[selectedDelivery]?.shipmentStatus =='delivered')
                                 &&
                                hours >= 24 && hours <= 144"
                          (click)="openLateReturnSheet(item)">
                    Late Return
                  </button>
                </div>
                 
                 </div>
            </div>
        </div>
        </div>
        </div>
        <div *ngIf="deliveries?.length<=1 && !(deliveryData[selectedDelivery]?.shipmentStatus == 'Confirmed')  && ((orderDetails.orderCurrentStatus == 'Confirmed' &&  orderDetails.backOrders.length<=0) || !(orderDetails.orderCurrentStatus == 'Confirmed')) ">
            
        <div class="delivery-info" >
          <p *ngIf="orderDeliveryTimeFormatted && orderDeliveryTimeFormatted !== '0 minutes' "  class="delivery-time">
          Order delivered in {{ orderDeliveryTimeFormatted }}</p>
          <div *ngIf="deliveryData[selectedDelivery]?.deliveryTime ==null && deliveryData[selectedDelivery]?.shipmentStatus != 'delivered' " style="width: 100%;">
          <div class="expected-delivery-container">
            <div class="expected-header">
              <div class="tag-header">
              <img src="../../../../assets/images/order-details/right.png" class="icon-check">
              <span class="expected-title">Expected Delivery</span>
              </div>
              <div class="tag-slot smart-slot" *ngIf="orderDetails?.slotTag=='smartSlot'">
                <img src="../../../../assets/images/order-details/smart.png">
                <span>Smart Slot</span>
              </div>
               <div class="tag-slot smart-pickup" *ngIf="orderDetails?.slotTag=='pickUp'">
                <img src="../../../../assets/images/order-details/pick.png">
                <span>Pick Up</span>
              </div>
                <div class="tag-slot smart-instant" *ngIf="orderDetails?.slotTag=='instantDelivery'">
                <img src="../../../../assets/images/order-details/instant.png">
                <span>Instant</span>
              </div>
            </div>

  <div class="expected-time-box">
    <div class="tag-header">
    <div>
     <img src="../../../../assets/images/order-details//car.png">
     </div>
    <div class="time-line">
    <p class="time-text" *ngIf="orderDetails?.estimateSlotDeliveryTime != 'null' && !(orderDetails?.slotTag=='redeem')">
        <!-- {{ orderDetails.poEdt ? formatExpectedDeliveryTime(orderDetails.poEdt) : formatGoOrderEdt(orderDetails.orderConfirmTime) }} -->
          {{ formatExpectedDeliveryTime(orderDetails.estimateSlotDeliveryTime)  }}          
      </p>
       <p class="time-text" *ngIf="orderDetails?.estimateSlotDeliveryTime == 'null' && !(orderDetails?.slotTag=='redeem')">
        {{ formatGoOrderEdt(orderDetails.orderConfirmTime)  }}          
      </p>
        <p class="time-text" *ngIf="orderDetails?.slotTag=='redeem'">
        {{ orderDetails.reedemTag  }}          
      </p>
       <p class="slot-note" *ngIf="!(orderDetails?.slotTag)||orderDetails?.slotTag=='smartSlot'||orderDetails?.slotTag=='redeem'">Within your promised slot</p>
       <p class="slot-note" *ngIf="orderDetails?.slotTag=='pickUp'">Available at nearest store</p>
       <p class="slot-note" *ngIf="orderDetails?.slotTag=='instantDelivery'">Instant delivery</p>
    </div>
    </div>
    <div class="tag-slot smart-free" *ngIf="orderDetails?.shippingCharges==0 && orderDetails?.slotTag">
      <span>₹{{orderDetails?.shippingCharges}} shipping</span>
    </div>
   <div class="tag-slot smart-fee" *ngIf="orderDetails?.shippingCharges>0 && orderDetails?.slotTag">
      <span>₹{{orderDetails?.shippingCharges}} fee</span>
    </div>
  </div>
</div>
          </div>
        </div>
        <div class="order-tracking">
            <h2>Delivery Tracking
              <!-- <button *ngIf="isMobile"  (click)="shareOnWhatsAppmob()" class="ViewbtnShare">
                <img src="../../../../assets/images/share.png" alt="Share" style="width: 16%;">
                <span class="viewShare">Share Details</span>
              </button>
              <button *ngIf="!isMobile" (click)="shareOnWhatsApp()" class="ViewbtnShare">
                <img src="../../../../assets/images/share.png" alt="Share" style="width: 16%;">
                <span class="viewShare">Share Details</span>
              </button> -->
            </h2>
            
                
         <div class="progress-container">
    <div *ngFor="let status of statuses; let i = index" 
         [ngClass]="{'active': isActive(i), 'inactive': !isActive(i)}" 
         class="progress-step">
         <span class="circle">
            <i class="material-icons" style="font-size: 19px;color: white;">check</i>
          </span>
         
         <div class="orderlist" > 

          <img [src]="getStatusImage(status)" alt="{{getStatusName(status)}}" style="height: 23px; margin-top: 4px;"/>  
          <div class="statusDate">
          <span *ngIf="getStatusName(status)=='Confirmed'" [ngClass]="{'active-text': isActive(i)}">Confirmed </span>
          <span *ngIf="getStatusName(status)=='Packed'" [ngClass]="{'active-text': isActive(i)}">Packed </span>
          <span *ngIf="getStatusName(status)=='On The Way'" [ngClass]="{'active-text': isActive(i)}"> On The Way </span>
          <span *ngIf="getStatusName(status)=='Delivered'" [ngClass]="{'active-text': isActive(i)}">Delivered </span>
          
          <p class="dates" *ngIf="isActive(i)">{{ getStatusDate(status)  | date:'dd-MMM-yyyy, hh:mm a' : 'GMT+1060'  }}</p>
          </div>
        </div>
      
    </div>
  </div>
  <!-- <button *ngIf="orderDetails.invoice && orderDetails.invoice.length > 0" (click)="openInvoiceUrl()" class="Viewbtn">
    <img src="../../../../assets/images/download.png" alt="download" style="width: 16%;">
    <span class="view">Download Invoice</span>
  </button> -->

        
         
        </div>
        <div class="order-items">
          <h2>{{ count }} {{ count > 1 ? 'Items' : 'Item' }} in this delivery</h2>
          
          <div *ngFor="let item of orderDetails.orderItems">
            <div class="item">
              <span *ngIf="item.discount > 0" class="discount-badge"> 
                <!-- {{ ((item.discount / item.price) * 100) | number:'1.0-0' }}% Off -->
                  {{ ((item.discount / (item.price + item.discount)) * 100) | number:'1.0-0' }}% Off
              </span>
              <img *ngIf="item.imageUrl"  [src]="item.imageUrl" onerror="this.src='../../../../assets/images/logos/logo.png'">
           
              <img *ngIf="!item.imageUrl" src="../../../../assets/images/logos/logo.png" alt="logo">
              <div class="item-details">
                <!-- <h3>{{item.partName}}</h3> -->
                <h3 class="truncate-text">{{ item.partName }}</h3>
                <p> {{ item.quantity }} {{ item.quantity > 1 ? 'Units' : 'Unit' }}</p>
                <p>{{item.brandName}}</p>
                <p>{{item.partNumber}}</p>
                <div style="display: flex;justify-content: space-between;">
                  <div>
                    <div class="price">
                      
                      <span class="discounted-price" *ngIf="item.price >0">₹{{item.price *item.quantity |  number: '1.2-2'}}</span>
                      <span class="original-price" *ngIf="item.discount>0">₹{{(item.price+item.discount)*item.quantity |  number: '1.2-2'}}</span>
                    </div>
                    <p class="savings" *ngIf="item.discount>0">You save ₹{{item.discount * item.quantity |  number: '1.2-2'}}</p>
                  </div>
                  <button class="return-item" *ngIf="isReturned(item.partNumber) && deliveryData[selectedDelivery]?.shipmentStatus=='delivered'" (click)="trackReturn(item.partNumber)">Track Return</button>
                  <!-- (!isReturned(item.partNumber)) && (deliveryData[selectedDelivery]?.shipmentStatus=='delivered') && dueDate &&  -->
                  <button class="return-item" *ngIf="(!isReturned(item.partNumber)) && (deliveryData[selectedDelivery]?.shipmentStatus=='delivered') && hours<24" (click)="returnItem(item)">Return Item</button>
                
                  <button class="return-item"
                          *ngIf="!isReturned(item.partNumber) && (deliveryData[selectedDelivery]?.shipmentStatus =='delivered')
                                 &&
                                hours >= 24 && hours <= 144"
                          (click)="openLateReturnSheet(item)">
                    Late Return
                  </button>
                </div>
              </div>
            </div>
        </div>
        </div>
        </div>
        <div *ngIf="deliveryData[selectedDelivery]?.shipmentStatus =='Confirmed'|| (orderDetails.orderCurrentStatus == 'Confirmed' &&  orderDetails.backOrders.length>0)">
          <p class="tobe-delivered">To Be Delivered</p>
         <div  *ngIf=" orderDetails?.backOrders.length >0" class="confirm-tobe">
            <P class="subheading">Some items are in backorder and will be dispatched in separate deliveries</P>
            <div class="backorder-heading">
                <img src="../../../../assets/images/order-details/info.png">
              <p>Backordered items are being arranged from other Autoverse warehouses. They will be packed and dispatched as soon as they are available.</p>
            </div>
            
              <div class="order-items" *ngFor="let order of orderDetails?.backOrders">
          <h2>#PO-{{ order.b2bPoId }}</h2>
          <p class="backorder-status">Backorder</p>
          <div *ngFor="let item of order.itemInfo">
            <div class="item">
              <span *ngIf="item.discount > 0" class="discount-badge" style="margin-top: -20%;">
                <!-- {{ ((item.discount / item.price) * 100) | number:'1.0-0' }}% Off -->
                 {{ ((item.discount / (item.price + item.discount)) * 100) | number:'1.0-0' }}% Off
              </span>
              <img *ngIf="item.imageUrl"  [src]="item.imageUrl" style="padding: 10px;" onerror="this.src='../../../../assets/images/logos/logo.png'">
           
              <img *ngIf="!item.imageUrl" src="../../../../assets/images/logos/logo.png" alt="logo" style="padding: 10px;">
              <div class="item-details">
                <!-- <h3>{{item.partName}}</h3> -->
                <h3 class="truncate-text">{{ item.partName }}</h3>
                <div class="unit-brand">
                <p style="border-right: 1px solid gray;padding-right: 4px;font-size: 12px;"> {{ item.quantity }} {{ item.quantity > 1 ? 'Units' : 'Unit' }}</p>
                <p style="font-size: 12px;">{{item.brandName}}</p>
                </div>
                <p style="font-size: 12px;">{{item.partNumber}}</p>
                <div style="display: flex;justify-content: space-between;">
                    <div class="price">
                      <span class="discounted-price" style="margin-right: 0px;font-size: 12px;" *ngIf="item.price >0">₹{{item.price *item.quantity |  number: '1.2-2'}}</span>
                      <span class="original-price" style="font-size: 11px;" *ngIf="item.discount>0">₹{{(item.price+item.discount)*item.quantity |  number: '1.2-2'}}</span>
                    <p class="savings" style="margin-bottom: 0px; margin-left: 4px; font-size: 11px;" *ngIf="item.discount>0">You save ₹{{item.discount * item.quantity |  number: '1.2-2'}}</p>
                    </div>
                  <button class="return-item" *ngIf="isReturned(item.partNumber) && deliveryData[selectedDelivery]?.shipmentStatus=='delivered'" (click)="trackReturn(item.partNumber)">Track Return</button>
                    <button class="return-item" *ngIf="(!isReturned(item.partNumber)) && (deliveryData[selectedDelivery]?.shipmentStatus=='delivered') && dueDate && hours<24" (click)="returnItem(item)">Return Item</button>
                  <!-- <button class="return-item"
                          *ngIf="!isReturned(item.partNumber) && (deliveryData[selectedDelivery]?.shipmentStatus =='delivered'|| (orderDetails.orderCurrentStatus == 'Delivered'))
                                 &&
                                hours >= 24"
                          (click)="openLateReturnSheet(item)">
                    Late Return
                  </button> -->

                </div>
              </div>
            </div>
        </div>
        </div>
        </div>
        <div  *ngIf=" orderDetails?.notBackorderItems?.length >0" class="confirm-tobe">
            <P class="subheading">Some orders will be dispatched in separate deliveries </P>
            <div class="backorder-heading">
                <img src="../../../../assets/images/order-details/info.png">
              <p>Some items aren’t available at the nearest Autoverse warehouse. We’re checking other locations and will share the delivery time shortly.</p>
            </div>
            
              <div class="order-items" >
          <h2>{{ orderDetails?.notBackorderItems.length }} {{  orderDetails?.notBackorderItems.length > 1 ? 'Items' : 'Item' }} in this delivery</h2>
          <div class="eta">
            <p class="confirm-status">Confirmed</p>
            <div *ngIf="orderDetails.poEdt !=null" class="date-exp" >ETA: {{formatExpectedDeliveryTime(orderDetails.poEdt)}}</div>
            <div *ngIf="orderDetails.poEdt ==null" class="date-exp">ETA: {{formatGoOrderEdt(orderDetails.orderConfirmTime)}}</div>
          </div>
          <div *ngFor="let item of orderDetails?.notBackorderItems">
          <div class="item">
              <span *ngIf="item.discount > 0" class="discount-badge" style="margin-top: -20%;">
                <!-- {{ ((item.discount / item.price) * 100) | number:'1.0-0' }}% Off -->
                {{ ((item.discount / (item.price + item.discount)) * 100) | number:'1.0-0' }}% Off
              </span>
              <img *ngIf="item.imageUrl"  [src]="item.imageUrl" style="padding: 10px;" onerror="this.src='../../../../assets/images/logos/logo.png' ">
           
              <img *ngIf="!item.imageUrl" src="../../../../assets/images/logos/logo.png" alt="logo" style="padding: 10px;">
              <div class="item-details">
                <!-- <h3>{{item.partName}}</h3> -->
                <h3 class="truncate-text">{{ item.partName }}</h3>
                <div class="unit-brand">
                <p style="border-right: 1px solid gray;padding-right: 4px;font-size: 12px;"> {{ item.quantity }} {{ item.quantity > 1 ? 'Units' : 'Unit' }}</p>
                <p style="font-size: 12px;">{{item.brandName}}</p>
                </div>
                <p style="font-size: 12px;">{{item.partNumber}}</p>
                <div style="display: flex;justify-content: space-between;">
                    <div class="price">
                      <span class="discounted-price" style="margin-right: 0px;font-size: 12px;" *ngIf="item.price >0">₹{{item.price *item.quantity |  number: '1.2-2'}}</span>
                      <span class="original-price" style="font-size: 11px;" *ngIf="item.discount>0">₹{{(item.price+item.discount)*item.quantity |  number: '1.2-2'}}</span>
                    <p class="savings" style="margin-bottom: 0px; margin-left: 4px; font-size: 11px;" *ngIf="item.discount>0">You save ₹{{item.discount * item.quantity |  number: '1.2-2'}}</p>
                    </div>
                  <button class="return-item" *ngIf="isReturned(item.partNumber) && deliveryData[selectedDelivery]?.shipmentStatus=='delivered'" (click)="trackReturn(item.partNumber)">Track Return</button>
                  <button class="return-item" *ngIf="(!isReturned(item.partNumber)) && (deliveryData[selectedDelivery]?.shipmentStatus=='delivered') && dueDate && hours<24" (click)="returnItem(item)">Return Item</button>
                  <!-- <button class="return-item"
                          *ngIf="!isReturned(item.partNumber) && (deliveryData[selectedDelivery]?.shipmentStatus =='delivered'|| (orderDetails.orderCurrentStatus == 'Delivered'))
                                 &&
                                hours >= 24"
                          (click)="openLateReturnSheet(item)">
                    Late Return
                  </button> -->

                </div>
              </div>
            </div>
        </div>
        </div>
        </div>
        </div>
        <div class="price-details">
          <h2 class="priceDet">Total Order Price Details</h2>
          <div class="details">
            <p>Spares Total <span>₹{{orderDetails.grandTotal+orderDetails.discount |  number: '1.2-2'}}</span></p>
            <p >Spares Discount <span style="color: #4caf50;">₹{{orderDetails.discount |  number: '1.2-2'}}</span></p>
            <div class="infoiconnew"*ngIf="orderDetails.shippingCharges == 0" style="margin-bottom: 0px;    justify-content: flex-start;">Shipping Charges
                <i style="cursor: pointer; margin-top: -1px;"class="maticon" mat-raised-button  (click)="openBottomSheet()">
                info_outline
              </i>
             
                <div class="freetag"  style="text-decoration: line-through;margin-left: auto;"> ₹ {{orderDetails.shippingCharges}}
                  <span style="color: #4caf50;">FREE</span>
                </div>
              </div>
            

                  <p *ngIf="orderDetails?.shippingCharges && orderDetails?.shippingCharges > 0" style="margin-bottom: 0px;    justify-content: flex-start;">Shipping Charges
                    <i style="cursor: pointer;" class="maticon1" mat-raised-button  (click)="openBottomSheet()">
                      info_outline
                    </i>
                  
                    <span style="margin-left: auto;">₹{{orderDetails.shippingCharges}}</span>
                  </p>
                    
                    <div class="slot-badge" *ngIf="orderDetails?.slotTag=='smartSlot'">
                        <img src="../../../../assets/images/slot-delivery/car1.png">
                        <span>FREE Smart Slot</span>
                    </div>
                    <div class="slot-badge" *ngIf="orderDetails?.slotTag=='pickUp'">
                        <img src="../../../../assets/images/slot-delivery/location-color.png">
                        <span>Free Pickup from Store</span>
                    </div>
                     <div class="slot-badge" *ngIf="orderDetails?.slotTag=='instantDelivery'">
                        <img src="../../../../assets/images/slot-delivery/instant-pick.png">
                        <span *ngIf="orderDetails.shippingCharges>0 ">Instant Delivery - Chargeable</span>
                        <span *ngIf="orderDetails.shippingCharges==0 ">Instant Delivery - FREE</span>
                    </div>
                  <ng-template #bottomSheetTemplate >
                    <div class="bottom-sheet-content">
                      <i style="cursor: pointer;" class="material-icons" (click)="closeBottomSheet()" style="float: left;font-size: 17px; cursor: pointer;">cancel</i>                    
                      <h3 style="font-weight: bold;">Shipping Charge</h3>
                      <p style="font-size: 13px;">Autoverse provides free Shipping for orders above ₹{{orderDetails?.avoidShippingCharges}}</p>
                      <button mat-button class="custom-button" (click)="closeBottomSheet()">Okay, Got it</button>
                    </div>
                  </ng-template> 
            <!-- <p style="font-weight: bold; color: black;">Total <span style="color: black; font-weight: bold;">₹{{orderDetails.grandTotal |  number: '1.2-2'}}</span></p> -->
            <p class="grand_total">Grand Total <span style="color: black; font-weight: bold;">₹{{ orderDetails.grandTotal+orderDetails.shippingCharges | number: '1.2-2' }}</span></p>
            <p *ngIf="orderDetails?.walletAmount">Wallet Amount Paid <span style="color: #4caf50;">₹{{orderDetails.walletAmount |  number: '1.2-2'}}</span></p>
            <p *ngIf="orderDetails?.prepaidAmount">Online Payment<span style="color: #4caf50;">₹{{orderDetails.prepaidAmount |  number: '1.2-2'}}</span></p>
            <p style="font-weight: bold; color: black;" *ngIf="orderDetails?.walletAmount || orderDetails?.prepaidAmount">Balance Payable <span style="color: black; font-weight: bold;">₹ {{getBalancePayable()}}</span></p>
           </div>
        </div>
        <div class="order-details">
          <h2 class="priceDet">Order Details</h2>
          <h4 style="margin-bottom: -11px;">Payment</h4>
          <p>{{orderDetails.paymentMethod}}</p>
          <h4 style="margin-bottom: -11px;">Delivered To
          </h4>
          
          <p>{{orderDetails.shippingAddress}}</p>
          <h4 style="margin-bottom: -11px;">Order placed</h4>
          <p>{{orderDetails.orderDate | date:'dd-MMM-yyyy, hh:mm a': 'GMT+1060'}}</p>
        </div>

        <div class="delivery-updates" style="margin-bottom: 75px;">
  <h3 *ngIf="timelineData">Delivery Updates</h3>
      <div class="timeline">
        <div
          class="timeline-item"
          *ngFor="let step of timelineData; let i = index">
          <div class="time" [class.active]="i === 0">{{ step.createdAt }}</div>
          <div *ngIf="i !== 0" class="green-tick">
            <img src="../../../../assets/images/order-details/div1.png">
          </div>
          <div *ngIf="i == 0" class="blueshadow">
            <img src="../../../../assets/images/order-details/div.png">
          </div>
          <div class="content" [class.completed]="i == 0">
            <div class="title">{{ step.heading }}</div>
            <div class="description">{{ step.message }}</div>
          </div>
        </div>
      </div>
  </div>

        
        <button *ngIf="deliveryData[selectedDelivery]?.trackingUrl && deliveries?.length> 1" (click)="openTracking(deliveryData[selectedDelivery]?.trackingUrl)" class="ViewbtnTrack">
          <img src="../../../../assets/images/order-details/orderTrack.png" alt="Track" style="width: 14%;">
          <span class="viewTrack">Track your order</span>
        </button>
        <button *ngIf="trackingUrl && deliveries?.length<=1" (click)="openTracking(trackingUrl)" class="ViewbtnTrack">
          <img src="../../../../assets/images/order-details/orderTrack.png" alt="Track" style="width: 14%;">
          <span class="viewTrack">Track your order</span>
        </button>
        <div class="fixed-reorder">

          <button class="reorder-button" (click)="getReorder(orderKey)" *ngIf="orderDetails.orderCurrentStatus=='Delivered' && isVisible && deliveries?.length<=1" [ngClass]="{'active-text': isActive(index)}">Reorder</button>
        <button class="reorder-button" (click)="getReorder(orderKey)" *ngIf="deliveryData[selectedDelivery]?.shipmentStatus=='delivered' && isVisible  && deliveries?.length> 1" [ngClass]="{'active-text': isActive(index)}">Reorder</button>
        <button class="reorder-button" (click)="openTracking(trackingUrl)" *ngIf="orderDetails.orderCurrentStatus!='Delivered' && trackingUrl!=null && isVisible && deliveries?.length<=1" [ngClass]="{'active-text': isActive(index)}">Track Order</button>
         <button class="reorder-button" (click)="openTracking(deliveryData[selectedDelivery]?.trackingUrl)" *ngIf="deliveryData[selectedDelivery]?.shipmentStatus!='delivered' && deliveryData[selectedDelivery]?.trackingUrl && isVisible && deliveries?.length> 1" [ngClass]="{'active-text': isActive(index)}">Track Order</button>

      </div>
    
      </div>
  </div>
  <!-- BACKDROP -->
  <form [formGroup]="registerForm">
    <div class="register-sheet-backdrop" *ngIf="showRegisterSheet" (click)="closeRegisterSheet()"></div>

    <div class="register-sheet-container" *ngIf="showRegisterSheet">
      <div class="register-sheet-content">
        <div class="heading-with-close">
          <h2 class="sheet-title">Warranty Certificate</h2>
          <!-- <button mat-button color="warn" class="close-btn" (click)="closeRegisterSheet()">
            Close
          </button> -->
          <mat-icon (click)="closeRegisterSheet()" style="color: #666; cursor: pointer;">close</mat-icon>
        </div>
        
        <!-- REGISTRATION NUMBER -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Registration Number <span class="red-star">*</span></mat-label>
          <input matInput formControlName="regno" placeholder="KA03AB1234">
          <mat-error *ngIf="submitted && registerForm.controls['regno'].hasError('required')">
             Enter valid registration number
          </mat-error>
        </mat-form-field>

        <!-- NAME -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Name <span class="red-star">*</span></mat-label>
          <input matInput formControlName="name"   maxlength="20" placeholder="Enter name">
          <mat-error *ngIf="submitted && registerForm.controls['name'].hasError('required')">
            Enter the customer's name
          </mat-error>
        </mat-form-field>

        <!-- MOBILE NUMBER -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Mobile Number <span class="red-star">*</span></mat-label>
          <!-- <span matPrefix>+91&nbsp;</span> -->
          <input matInput type="tel" formControlName="mobile"  maxlength="10" placeholder="Enter mobile number">
          <mat-error *ngIf="submitted && registerForm.controls['mobile'].hasError('required')">
            Enter valid mobile number
          </mat-error>
          <mat-error *ngIf="submitted && registerForm.controls['mobile'].hasError('pattern')">
             Enter valid mobile number
          </mat-error>
        </mat-form-field>

        <!-- ODOMETER -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Odometer Reading <span class="red-star">*</span></mat-label>
          <input matInput type="text"   inputmode="numeric"
            pattern="[0-9]*" formControlName="odometer" placeholder="Enter reading">
          <mat-error *ngIf="submitted && registerForm.controls['odometer'].hasError('required')">
            Odometer reading is required
          </mat-error>
        </mat-form-field>

        <!-- BUTTON -->
        <button mat-raised-button color="primary" class="action-btn" (click)="onRegisterParts()">
          Issue Warranty Certificate
        </button>
      </div>
    </div>
  </form>

  <!-- SUCCESS POPUP -->
  <!-- <div class="popup-backdrop" *ngIf="showSuccessPopup"></div> -->
  <div class="overlay" [class.visible]="showSuccessPopup" (click)="closeSuccessPopup()"></div>
  <div class="success-popup" *ngIf="showSuccessPopup">
    <mat-icon class="popup-close-success" (click)="closeSuccessPopup()">close</mat-icon>
    <div >
      <img [src]="successIcon" class="success-icon">
    </div>
    <h2 class="popup-title">Warranty Certificate Issued</h2>

    <p class="popup-id">
      Certificate ID : <span>{{ registeredData?.id }}</span>
    </p>

    <p class="popup-date">
      {{ registeredData?.createdAt  | date:'dd MMM yyyy, hh:mm a': 'GMT+1060' }}
    </p>

    <p class="have-successfully-msg-txt">Your warranty certificate has been successfully generated.</p>
    <button class="popup-btn" (click)="goToWarrantyList()">
      VIEW WARRANTY CERTIFICATE
    </button>

  </div>

  </div>
<div #dynamicContainer></div>

<div class="overlay" [class.visible]="showLateReturnSheet" (click)="closeLateReturnSheet()"></div>
<div class="late-return-backdrop" *ngIf="showLateReturnSheet" (click)="closeLateReturnSheet()"></div>

<div class="late-return-sheet" *ngIf="showLateReturnSheet">
  <div class="late-rtrn-main-card">
    <mat-icon *ngIf="showLateReturnSheet" (click)="closeLateReturnSheet()" style="float: right; cursor: pointer;">close</mat-icon>
    <div class="image-icon">
      <img src="../../../../assets/images/late-return-handshake.png">
    </div>
    <div class="here-for-you">We're Here for You</div>
    <div class="p-classes">
      <p class="sometimes-returns-take-longer">
        We know sometimes returns take longer. You can still request it, but we'll check first.
      </p>
      <p class="Late-returns-may-be-declined">
        Late returns may be declined, but we will try our best to help you.
      </p>
    </div>
     <button mat-raised-button color="primary" (click)="returnItemForAll()">
      Request Late Return
    </button>
  </div>
</div>



<div class="popup-overlays" *ngIf="freeShipping && orderDetails?.slotTag=='smartSlot'">
<div class="popup-modal">

    <!-- Header -->
    <div class="popup-header">
    <img src="../../../../assets/images/slot-delivery/light-car.png" class="popup-icon">
    
    <h2 class="popup-title" style="color: black;">Why is shipping FREE?</h2>
    <i class="popup-close" (click)="closeShipping()">close</i>
    </div>

    <!-- Title & Subtitle -->
    <p class="popup-subtitle" style="color: #6B7280;">
    You chose Smart Slot. We club orders and deliver in a predictable slot.
    </p>

    <!-- Delivery Info -->
    <!-- <div class="popup-row light-blues" style="border: 1px solid #BAE6FD;color: #0369A1;">
    <span class="popup-row-icon">⏱</span>
    <span>Arrives {{ getDeliveryLabel(slotData?.currentSlot.customerDeliveryTime) }}</span>
    </div> -->
    <!-- <p class="popup-subtext" style="color: #6B7280;">Order By: {{ getUpcoming(slotData?.currentSlot.orderWindowEnd) }}</p> -->

    <!-- Benefits List -->
    <div class="popup-benefits">
    <p><img src="../../../../assets/images/slot-delivery/doller.png"> Fewer trips, lower logistics cost</p>
    <p><img src="../../../../assets/images/slot-delivery/right.png"> Predictable delivery window</p>
    <p><img src="../../../../assets/images/slot-delivery/doller.png"> ₹{{orderDetails.shippingCharges | number:'1.0-0'}} shipping for this order</p>
    </div>

    <!-- <p class="popup-note" style="color: #9CA3AF;">
    Change delivery at the previous step if you need Instant.
    </p>
    <div class="popup-actions">
    <button class="popup-btn primary" (click)="closeShipping()">Keep Smart Slot</button>
    <button class="popup-btn secondary" (click)="goToSlot()">Change delivery</button>
    </div> -->
    
</div>
</div>
<div class="popup-overlays"  *ngIf="freeShipping && orderDetails?.slotTag=='pickUp'">
<div class="popup">

<div class="header">
    <span class="header1">
    <img class="icon" src="../../../../assets/images/slot-delivery/color-location.png" style="width: 13%;">
    <h2>Why is shipping FREE?</h2>
    </span>
    <i (click)="closeShipping()">close</i>
</div>

<p class="subtext">Pick up from our store—no shipping fee.</p>

<div class="location-box">
    <div class="location">
    <img class="location-icon" src="../../../../assets/images/slot-delivery/location-color.png">
    <div class="location-details">
        <div class="address">{{orderDetails.shippingAddress}} </div>
        <div class="hours">Open 9:30 AM-6:30 PM</div>
    </div>
    </div>
</div>

<div class="tags">
    <div class="tag no-fee"  *ngIf="orderDetails.shippingCharges ==0">🚫 No shipping fee</div>
    <div class="tag priority">⚡ Priority counter</div>
</div>

<!-- <button class="btn" (click)="openMap()">Get Directions</button>

<div class="change-link" (click)="goToSlot()">Change delivery</div> -->

<!-- <p class="note">Bring your Order ID at the counter.</p> -->
</div>

</div>
<div class="overlay1" (click)="closeShipping()"  [class.visible]="freeShipping" *ngIf="freeShipping" ></div>

<div class="modal" *ngIf="freeShipping && orderDetails?.slotTag=='instantDelivery' && orderDetails.shippingCharges>0">
    <div class="close">
  <h2 style="margin: 0">🕒 Why am I paying ₹{{orderDetails.shippingCharges}}?</h2>
    <i (click)="closeShipping()">close</i>
    </div>
  <p class="subtext">Instant sends a separate trip to deliver immediately.</p>
  <p class="free-offer">✨ Free instant delivery on orders above ₹{{orderDetails?.avoidShippingCharges}}</p>

  <!-- <div class="tip-box">
    <p class="tip">💡 Tip: Choose Smart Slot & Save ₹{{shippingCharges}}</p>
    <p class="catch">⏳{{convertMinutesToTimeLabel(slotData?.currentSlot.orderConfirmTime)}} left to catch {{ getUpcoming(slotData?.currentSlot.customerDeliveryTime) }} delivery</p>
    <button class="primary" (click)="switchToSmartSlot()">Switch to Smart Slot</button>
  </div>

  <button class="secondary" (click)="closeShipping()">Continue with Instant</button> -->
</div>

<!-- modal -->
<div class="modal" *ngIf="freeShipping && orderDetails?.slotTag=='instantDelivery' && orderDetails.shippingCharges==0">
  <div class="close">
  <h2>🕒 <strong>Instant is free today</strong></h2>
  
    <i (click)="closeShipping()">close</i>
    </div>
  <p class="subtext" style="color: black;">
    You're not paying a delivery fee on orders above ₹{{orderDetails?.avoidShippingCharges}}.
  </p>

  <!-- <p class="green-tip" style="text-align: left;">
    💡 Still better: Smart Slot arrives {{ getDeliveryLabel(slotData?.currentSlot.customerDeliveryTime) }} and helps cut extra trips.
  </p>

  <div class="info-box">
    <p class="green-tip">✨ Choose Smart Slot for predictable delivery</p>
    <p class="catch">⏳ {{convertMinutesToTimeLabel(slotData?.currentSlot.orderConfirmTime)}} left to catch {{ getUpcoming(slotData?.currentSlot.customerDeliveryTime) }} delivery</p>
    <button class="primary" (click)="switchToSmartSlot()">Choose Smart Slot</button>
  </div>

  <button class="secondary" (click)="closeShipping()">
    Proceed with Instant
  </button> -->



</div>

